import axios from 'axios'
import Utils from '@/common/Utils'
import store from '../store'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class UserService {
    static async getOne (userId) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/user/${userId}`, { headers })
            if (data.status === 'success') return Promise.resolve(data.data)
            return Promise.resolve({})
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getAll () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/users`, { headers })
            return Promise.resolve(data.data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async update (id, payload) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            payload.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            payload.userId = store.getters.user ? store.getters.user.userId : null

            let { data } = await axios.put(`${url}/user/${id}`, payload, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    /**
     * @DEPRECATED
     * A partir de aqui encontramos metodos que le pegan a rutas anteriores cuando se utilizaba Knex.
     * Se mantienen para no romper la aplicación e ir cambiando esto a
     * que se utilice Sequelize.
    */

    static async getAllUsers () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/getUsers`, { headers })
            if (data.status === 'success') return Promise.resolve(data.data)
            return Promise.resolve([])
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async createUser (newUser) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/createUser`, newUser, { headers })
            if (data.status === 'success') return Promise.resolve(true)
            else return Promise.resolve(false)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getById (userId) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/getUser/${userId}`, { headers })
            if (data.status === 'success') return Promise.resolve(data.data)
            return Promise.resolve({})
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async saveUser (userData) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/saveUser`, userData, { headers })
            if (data.status === 'success') return Promise.resolve(true)
            return Promise.resolve(false)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async resetUserAccess (userId) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/resetUserAccess`, { userId: userId }, { headers })
            if (data.status === 'success') return Promise.resolve(true)
            return Promise.resolve(false)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async toggleBlockUser (userId, block) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/toggleUserAccess`, { userId: userId, block: block }, { headers })
            if (data.status === 'success') return Promise.resolve(true)
            return Promise.resolve(false)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async sendResetLink (email) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/sendResetLink/${email}`, { headers })
            if (data.status === 'success') return Promise.resolve(data.data)
            return Promise.resolve(null)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async resetPassword (id, token) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/resetPassword/${id}/${token}`, { headers })
            if (data.status === 'success') return Promise.resolve(data.data)
            return Promise.resolve(null)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }
}
